define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/select-avatar/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/select-avatar/1.0.0/index.css'
  /* eslint-enable */
], function selectAvatarModule(app, html, css) {
  'use strict';

  app.registerComponent('selectAvatar', {
    require: {},
    bindings: {
      avatars: '<',
      hideCancel: '<?',
      selectedAvatar: '<?',
      selectCallback: '&',
      cancelCallback: '&'
    },
    controller: 'SelectAvatarController',
    template: html
  });

  app.registerController('SelectAvatarController', [
    '$scope',
    '$element',
    'compileService',
    'applicationPathName',
    function controller($scope, $element, compileService, applicationPathName) {
      var _this = this;
      _this.applicationPathName = applicationPathName;

      compileService.compile({css: css}, $scope, $element);
      _this.$onDestroy = function onDestroy() {};
    }
  ]);
});
